import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RoleType } from 'src/app/modules/auth/enums/RoleType';
import { RoleUtils } from 'src/app/modules/auth/helpers/role.utils';
import { AuthModel } from 'src/app/modules/auth/models/auth.model';
import { UserModel } from 'src/app/modules/auth/models/user.model';
import { AuthQuery } from 'src/app/modules/auth/state/auth.query';
import { AuthService } from 'src/app/modules/auth/state/auth.service';
import { DialogUtils } from 'src/app/modules/crm/modules/agenda/helpers/dialog.utils';
import { MessageModel } from 'src/app/modules/crm/modules/messages/models/message.model';
import { AgenziaModel } from 'src/app/modules/crm/modules/settings/models/agenzia.model';
import { PageableModel } from '../../models/pageable.model';
import { CrudService } from '../../services/crud.service';
import { GeneralQuery } from '../../state/general.query';
import { GeneralService } from '../../state/general.service';
import * as moment from 'moment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public isMenuCollapsed = true;

  adminRole = RoleType.ADMIN;
  agencyAdminRole = RoleType.AGENCY_ADMIN;
  ownerRole = RoleType.OWNER;

  public agenzie: AgenziaModel[] = new Array<AgenziaModel>();

  errors: HttpErrorResponse | undefined = undefined;
  public isLoading = false;

  public user = this.authQuery.auth?.user;
  public agenzia = this.authQuery.agenzia;

  public messagesCount = this.generalQuery.messageCount;
  public notifications$ = this.generalQuery.selectIsNotifications$;

  agenziaObs = new Array<any>();
  countObs = new Array<any>();

  constructor(private authQuery: AuthQuery, private authService: AuthService,
    private generalQuery: GeneralQuery, private generalService: GeneralService,
    private crudService: CrudService<AgenziaModel>, private crudServiceMessage: CrudService<MessageModel>,
    private _overlay: Overlay, private injector: Injector) { }

  ngOnInit(): void {
    if (this.checkRole(this.adminRole)) {
      // TODO remove 10 limits on agenzia
      this.crudService.getPage('agenzia', 0, 10,
        'created.asc', {})
        // tslint:disable-next-line: deprecation
        .subscribe(
          (agenzie: PageableModel<AgenziaModel>) => {
            this.agenzie = agenzie.content;
          },
          error => {
            this.errors = error;
          },
          () => {
            this.isLoading = false;
          });

      const obs = this.authQuery.selectIsAgenzia$.subscribe(c => {
        this.agenzia = c;
      });
      this.agenziaObs.push(obs);
    }

  
    this.crudServiceMessage.getPage('message', 0, 20,
      'created.asc', { read: { value: false, matchMode: 'match' } }, { direction: 'received' })
      // tslint:disable-next-line: deprecation
      .subscribe(
        (items: PageableModel<MessageModel>) => {
          this.generalService.setMessageCount(items.totalElements);
          for (const message of items.content) {
            DialogUtils.openPostItOverlay(event, -200, -200, this._overlay,
              this.injector, message.id, message.title, message.body, message);
          }
        },
        error => {
          this.errors = error;
        },
        () => {
          this.isLoading = false;
        });

    const obsc = this.generalQuery.selectIsMessageCount$.subscribe(c => {
      this.messagesCount = c;
    });
    this.countObs.push(obsc);

  }

  ngOnDestroy(): void {
    for (const obs of this.agenziaObs) {
      obs.unsubscribe();
    }
    for (const obs of this.countObs) {
      obs.unsubscribe();
    }
  }

  onLogout(): void {
    this.authService.logout();
  }

  checkRole(role: RoleType): boolean {
    return RoleUtils.checkRole(this.user?.roles, role);
  }

  setAgenzia(agenzia: AgenziaModel, op: any): void {
    this.authService.setAgenzia(agenzia);
    op.hide();
  }

  setNotificationRead(notification: any, notificationPanel:any){
    this.generalService.removeNotification(notification);
    if(this.generalQuery.notifications.length == 0){
      notificationPanel.hide()
    }
  }

  getNotificationTitle(notification: any){
    var date = moment(notification.notification.title);
    return date.format('DD/MM/YYYY HH:mm');
  }

}
